<mat-card class="h-full overflow-auto">
    <mat-card-header class="mb-6">
        <mat-card-title class="text-2xl font-semibold">{{ title() }}</mat-card-title>
        <mat-card-subtitle>{{ subtitle() }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <form class="grid gap-4 grid-cols-1 lg:grid-cols-2" [formGroup]="updateForm" (ngSubmit)="submit()">
            <mat-form-field appearance="outline">
                <mat-label>First name</mat-label>
                <input matInput type="text" formControlName="firstName">
                @if (updateForm.controls.firstName.invalid && updateForm.controls.firstName.touched) {
                    <mat-error>First name is required.</mat-error>
                }
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Last name</mat-label>
                <input matInput type="text" formControlName="lastName">
                @if (updateForm.controls.lastName.invalid && updateForm.controls.lastName.touched) {
                    <mat-error>Last name is required.</mat-error>
                }
            </mat-form-field>

            @if (includeAssignments()) {
                <mat-form-field appearance="outline">
                    <mat-label>Portal *</mat-label>
                    <mat-select formControlName="portalId">
                        <mat-option value="">Select portal</mat-option>
                        @for (item of portals(); track item.id) {
                            <mat-option [value]="item.id">{{ item.name }}</mat-option>
                        }
                    </mat-select>
                    @if (updateForm.controls.portalId.invalid && updateForm.controls.portalId.touched) {
                        <mat-error>Portal is required.</mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>User role *</mat-label>
                    <mat-select formControlName="userRoleId">
                        <mat-option value="">Select user role</mat-option>
                        @for (item of userRoles(); track item.id) {
                            <mat-option [value]="item.id">{{ item.name }}</mat-option>
                        }
                    </mat-select>
                    @if (updateForm.controls.userRoleId.invalid && updateForm.controls.userRoleId.touched) {
                        <mat-error>User role is required.</mat-error>
                    }
                </mat-form-field>

                @if (isClientPortal()) {
                    <mat-form-field appearance="outline">
                        <mat-label>Client</mat-label>
                        <mat-select formControlName="clientId">
                            <mat-option value="">No client</mat-option>
                            @for (item of clients(); track item.id) {
                                <mat-option [value]="item.id">{{ item.name }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                }

                @if (isAffiliatePortal()) {
                    <searchable-lookup-select
                        [formControl]="updateForm.controls.affiliateId"
                        label="Affiliate"
                        placeholder="No affiliate"
                        searchPlaceholder="Search affiliates"
                        loadingLabel="Loading affiliates..."
                        [options]="affiliateOptions()"
                        [loading]="affiliateOptionsLoading()"
                        (searchChanged)="affiliateSearchChanged.emit($event)" />
                }
            }

            <div class="col-span-1 lg:col-span-2 flex justify-end pt-2 gap-2">
                <button mat-flat-button type="submit" [disabled]="busy()">
                    @if (busy()) {
                        Saving...
                    } @else {
                        {{ submitLabel() }}
                    }
                </button>
                <ng-content/>
            </div>
        </form>
    </mat-card-content>
</mat-card>
